module.exports = __webpack_public_path__ + "img/logo_light.8afd9c97.svg";